import type { LandmarkConfig, RoomBounds, TableConfig } from '../types';

export interface LayoutConfig {
  tables: TableConfig[];
  landmarks: LandmarkConfig[];
  room: RoomBounds;
  seatRadius: number;
  seatTextOffset: number;
  rectangleWidth: number;
  rectangleHeight6: number;
  rectangleHeight7: number;
  roundTableRadius: number;
  roundSeatRingRadius: number;
}

const RECT_WIDTH = 100;
const RECT_HEIGHT = 200;
const ROOM: RoomBounds = { x: 190, y: 100, width: 1190, height: 850 };
const ROUND_TABLE_RADIUS = 32;
const ROUND_SEAT_RING_RADIUS = 64;
const ROUND_SEAT_COUNT = 10;

const rowY = [300, 485, 670, 855];
const topRowX = [450, 665, 880, 1095, 1310];
const offsetRowX = [345, 560, 775, 990, 1205];

const makeRound = (tableNumber: number, x: number, y: number): TableConfig => ({
  tableNumber,
  type: 'round',
  x,
  y,
  radius: ROUND_TABLE_RADIUS,
  seatRingRadius: ROUND_SEAT_RING_RADIUS,
  seatCount: ROUND_SEAT_COUNT,
  seatStartAngle: Math.PI,
  seatDirection: -1
});

const dinnerTables: TableConfig[] = [
  ...[19, 18, 17, 16, 15].map((table, index) => makeRound(table, topRowX[index], rowY[0])),
  ...[10, 11, 12, 13, 14].map((table, index) => makeRound(table, offsetRowX[index], rowY[1])),
  ...[9, 8, 7, 6, 5].map((table, index) => makeRound(table, topRowX[index], rowY[2])),
  ...[1, 2, 3, 4].map((table, index) => makeRound(table, offsetRowX[index + 1], rowY[3]))
];

const landmarks: LandmarkConfig[] = [
  {
    kind: 'room',
    x: ROOM.x,
    y: ROOM.y,
    width: ROOM.width,
    height: ROOM.height
  },
  { kind: 'entryDoor', x: 360, y: 126, text: 'GUEST ENTRY\nTO DINNER' },
  { kind: 'entryDoor', x: 740, y: 126, text: 'GUEST ENTRY\nTO DINNER' },
  { kind: 'entryDoor', x: 1095, y: 126, text: 'GUEST ENTRY\nTO DINNER' },
  {
    kind: 'fireplace',
    x: 380,
    y: 1010,
    width: 235,
    height: 58,
    text: 'FIREPLACE'
  },
  {
    kind: 'fireplace',
    x: 1390,
    y: 1010,
    width: 235,
    height: 58,
    text: 'FIREPLACE'
  }
];

export const defaultLayout: LayoutConfig = {
  seatRadius: 11,
  seatTextOffset: 8,
  rectangleWidth: RECT_WIDTH,
  rectangleHeight6: RECT_HEIGHT,
  rectangleHeight7: RECT_HEIGHT,
  roundTableRadius: ROUND_TABLE_RADIUS,
  roundSeatRingRadius: ROUND_SEAT_RING_RADIUS,
  room: ROOM,
  landmarks,
  tables: dinnerTables
};

export function getLayout(): LayoutConfig {
  return defaultLayout;
}
